module.exports = __webpack_public_path__ + "img/IMG_0300_L_Foamcore_MockedUp.b8e96941.jpg";